import React from 'react';
import {Helmet} from 'react-helmet';
import {getOutlet} from 'reconnect.js';
import LoginModal from '../../Components/LoginModal';
import ResetPasswordModal from '../../Components/ResetPasswordModal';
import GlobalSpinner from '../../Components/GlobalSpinner';

export function renderGlobalHtmlHelmet() {
  return (
    <Helmet>
      <meta
        name="facebook-domain-verification"
        content="em9qdq5zi7a6r70507ddmhz0ibho7e"
      />
    </Helmet>
  );
}

export function renderGlobalModals() {
  return (
    <>
      <LoginModal />
      <ResetPasswordModal />
      <GlobalSpinner />
    </>
  );
}
